import { __assign } from "tslib";
import React, { useEffect } from 'react';
import clsx from 'clsx';
import styles from './styles.css.js';
import InternalIcon from '../../icon/internal';
import ItemsList from '../items-list';
import MobileExpandableGroup from '../mobile-expandable-group/mobile-expandable-group';
import Tooltip from '../tooltip.js';
import useHiddenDescription from '../utils/use-hidden-description.js';
var MobileExpandableCategoryElement = function (_a) {
    var _b, _c, _d;
    var item = _a.item, onItemActivate = _a.onItemActivate, onGroupToggle = _a.onGroupToggle, targetItem = _a.targetItem, isHighlighted = _a.isHighlighted, isExpanded = _a.isExpanded, highlightItem = _a.highlightItem, disabled = _a.disabled, variant = _a.variant;
    var highlighted = isHighlighted(item);
    var expanded = isExpanded(item);
    var triggerRef = React.useRef(null);
    useEffect(function () {
        if (triggerRef.current && highlighted && !expanded) {
            triggerRef.current.focus();
        }
    }, [expanded, highlighted]);
    var triggerClickHandler = function (e) {
        if (!disabled) {
            e.preventDefault();
            onGroupToggle(item, e);
        }
    };
    var onHover = function (event) {
        event.preventDefault();
        highlightItem(item);
    };
    var hasTooltip = !!item.disabledReason && item.disabled;
    var _e = useHiddenDescription(item.disabledReason), targetProps = _e.targetProps, descriptionEl = _e.descriptionEl;
    var trigger = item.text && (React.createElement("p", { onClick: triggerClickHandler, className: clsx(styles.header, styles['expandable-header'], styles["variant-" + variant], (_b = {},
            _b[styles.highlighted] = highlighted,
            _b[styles['rolled-down']] = expanded,
            _b[styles.disabled] = disabled,
            _b)), "data-testid": item.id, tabIndex: highlighted ? 0 : -1, ref: triggerRef },
        item.text,
        React.createElement("span", { className: clsx(styles['expand-icon'], (_c = {},
                _c[styles['expand-icon-up']] = expanded,
                _c)) },
            React.createElement(InternalIcon, { name: "caret-down-filled" })),
        hasTooltip && descriptionEl));
    return (React.createElement("li", __assign({ className: clsx(styles.category, styles["variant-" + variant], styles.expandable, (_d = {},
            _d[styles.expanded] = expanded,
            _d[styles.disabled] = disabled,
            _d[styles.highlighted] = highlighted || expanded,
            _d[styles.expandable] = true,
            _d)), role: "menuitem", "aria-haspopup": true, "aria-expanded": expanded, "aria-disabled": disabled ? 'true' : undefined, onMouseEnter: onHover, onTouchStart: onHover }, (hasTooltip ? targetProps : {})),
        React.createElement(MobileExpandableGroup, { open: expanded, trigger: hasTooltip ? React.createElement(Tooltip, { content: item.disabledReason }, trigger) : trigger }, item.items && expanded && (React.createElement("ul", { role: "menu", "aria-label": item.text, className: clsx(styles['items-list-container']) },
            React.createElement(ItemsList, { items: item.items, onItemActivate: onItemActivate, onGroupToggle: onGroupToggle, targetItem: targetItem, isHighlighted: isHighlighted, isExpanded: isExpanded, highlightItem: highlightItem, hasCategoryHeader: true, variant: variant }))))));
};
export default MobileExpandableCategoryElement;
